import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewer-question-last',
  templateUrl: './viewer-question-last.component.html',
  styleUrls: ['./viewer-question-last.component.scss']
})
export class ViewerQuestionLastComponent implements OnInit {
  passBtn:boolean=true;
  failedBtn:boolean=false;

  moudle_passBtn:boolean=false;
  moudle_failedBtn:boolean=false;

passClick(){
    this.passBtn=true;
    this.failedBtn=false;
    this.moudle_passBtn=false;
    this.moudle_failedBtn=false;
}
failedClick(){
  this.passBtn=false;
  this.failedBtn=true;
  this.moudle_passBtn=false;
  this.moudle_failedBtn=false;
}

moudle_passClick(){
  this.passBtn=false;
  this.failedBtn=false;
  this.moudle_passBtn=true;
  this.moudle_failedBtn=false;
}
moudle_failedClick(){
this.passBtn=false;
this.failedBtn=false;
this.moudle_passBtn=false;
this.moudle_failedBtn=true;
}
  constructor() { }

  ngOnInit(): void {
  }

}
